export const fileUpload = (roleId, binaryData) => {
    const data = new FormData();
    data.append('files', binaryData);
    return fetch(`${process.env.REACT_APP_API_URL}/api/v1/files/upload`, {
        method: 'POST',
        body: data
    })
        .then(resp => resp.json())
        .then(resp => resp.result)
        .catch(console.error);
};
